module.exports = __webpack_public_path__ + "img/OK.419ae118.svg";